import pdfDownload from '../../resources/pdf-download.png';

export function checkIsPDF(attachment) {
  return attachment.attachmentOriginalName.indexOf(".pdf") !== -1;
}

export function getDirectLink (attachment) {
  if(attachment.attachmentOriginalName.indexOf(".pdf") !== -1) return pdfDownload;
  return attachment.attachmentUrl;
}
